import React from 'react'
import { useTranslation } from 'react-i18next'
import { REVIEW_MODAL_TYPE } from 'state/review'
import Modal from 'particles/Modal'

const StatusModal: React.FC<any> = ({ selectedNum, handleMassAction, setOpen, type }) => {
    const [t] = useTranslation()
    return (
        <Modal
            title={
                type === REVIEW_MODAL_TYPE.APPROVE_PENDING
                    ? t('modalWindow.acceptStatusTitle', {
                          selectedNum,
                      })
                    : t('modalWindow.confirmationMessage.moveBackToPendingTitle', {
                          selectedNum,
                      })
            }
            subtext={
                type === REVIEW_MODAL_TYPE.APPROVE_PENDING
                    ? t('modalWindow.confirmationMessage.acceptStatusPartipostersBulkSubtitle', {
                          count: selectedNum,
                      })
                    : t('modalWindow.confirmationMessage.sendPartipostersBackToPendingBulkSubtitle', {
                          count: selectedNum,
                      })
            }
            size="m"
            primaryButtonProps={{
                label: type === REVIEW_MODAL_TYPE.APPROVE_PENDING ? t('button.acceptAll') : t('button.sendBackAll'),
            }}
            secondaryButtonProps={{
                label: t('button.cancel'),
            }}
            onConfirm={() => {
                handleMassAction()
                setOpen(false)
            }}
            onClose={() => setOpen(false)}
            hasIcon={false}
        />
    )
}

export default StatusModal
